// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/background.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pot-page{
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat bottom right / auto 40vh, rgb(232, 231, 227);
  width: 100%;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  font-family: 'Monaco', monospace;
  position: absolute;
  z-index: 0;
  overflow: auto;
}

.pot-container {
  padding: 2% 2%;
  background-color: transparent;
  border: none;
  text-align: center;
}

.pot-info {
  background-color: #bbb;
  color: #000000;
  margin-top: 2.5%;
  padding: 1% 0% 0% 1%;
  }
  
.pot-header {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  align-items: center;
  justify-content: center;
  }

.pot-plants {
  display: flex;
  align-items: center;
  width: 90%;
  justify-content: space-between;
  gap: 0.5em;
  margin-top: 1em;
}

.pot-plants p {
  flex: 1 1;
  min-width: 0;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  margin: 0;
  text-align: left;
}

.plant-add-btn-container {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.status-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 5px 0;
    font-size: small;
  }

.status-row > div {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex: 1 1;
    font-size: small;
}

.extra-button{
    background-color: #000;
}


.irrigate-select {
    padding: 8px;
    margin-right: 5px;
    border-radius: 5px;
    border: 1px solid #ccc;
    background-color: white;
    width: 60%;
}

.irrigate-select2 {
  padding: 8px;
  border-radius: 5px;
  border: 1px solid #ccc;
  background-color: white;
  width: 100%;
  margin-bottom: 2%;
}

.info-button {
    background-color: transparent;
    color: black;
    border: none;
    padding: 0;
    font-size: 20px;
    cursor: pointer;
    margin-left: 5%;
}

.custom-days-input {
    width: 50px;
    height: 30px;
    font-size: 12px;
    padding: 4px;
  }

.pot-loading{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.pot-width {
    width: 100%;
  }

.pot-status {
  width: 100%;
  margin: 0 auto;
}

.scrollable-table {
  overflow-x: visible;
  margin-bottom: 2%;
}

.status-table {
  width: 100%;
  max-width: 100%;
  table-layout: fixed;
}

th {
  padding: 5px 0;
  font-weight: bold;
  border-bottom: 2px solid #000000;
  white-space: normal;
  font-size: clamp(0.75rem, 1.35vw, 0.95rem);
}

td {
  white-space: normal;
  font-size: clamp(0.65rem, 1.1vw, 0.85rem);
}

.chart {
  min-height: 400px;
  width: 100%;
  overflow-x: visible;
}

.date-picker-container {
  padding: 20px;
}

.date-picker-container .react-datepicker-wrapper {
  padding: 10px;
}

.date-picker-container .react-datepicker {
  background-color: white;
  border: 1px solid #ccc;
}

.date-picker-container .react-datepicker__input-container input {
  width: 100%;
  padding: 10px;
  border: 2px solid #000000;
  border-radius: 5px; 
  font-size: 16px;
  background-color: #fff;
  text-align: center;
}

.date-picker-container .react-datepicker__input-container input:focus {
  outline: none;
  border-color: #0056b3;
  box-shadow: 0 0 5px rgba(0, 86, 179, 0.5);
}

.graph-container {
  background-color: #ffffff;
  color: rgb(0, 0, 0);
  margin-top: 2.5%;
  padding: 1% 0.5% 0.5% 1%;
}

.custom-legend {
  display: flex;
  gap: 20px;
  cursor: pointer;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  opacity: 1;
  transition: opacity 0.2s;
}

.legend-item.inactive {
  opacity: 0.4;
}

.legend-color {
  width: 18px;
  height: 5px;
  display: inline-block;
  border-radius: 2px;
  margin-right: 3px;
  border: none;
  background: #aaa;
}

.legend-color.dashed {
  border: 1.5px dashed #666;
}

.plant-name-flex {
    flex: 1 1;
}

.two-col-row {
    display: flex;
    gap: 2rem;
}

.two-col-row .input-group {
    flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/Pots.css"],"names":[],"mappings":"AAAA;EACE,0GAAmG;EACnG,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB;;AAEF;EACE,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;EACnB,uBAAuB;EACvB;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,8BAA8B;EAC9B,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,gBAAgB;EAClB;;AAEF;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;AACnB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,eAAe;IACf,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;EACd;;AAEF;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;IACI,WAAW;EACb;;AAEF;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;AACX","sourcesContent":[".pot-page{\n  background: url('../assets/background.webp') no-repeat bottom right / auto 40vh, rgb(232, 231, 227);\n  width: 100%;\n  min-height: 100vh;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Monaco', monospace;\n  position: absolute;\n  z-index: 0;\n  overflow: auto;\n}\n\n.pot-container {\n  padding: 2% 2%;\n  background-color: transparent;\n  border: none;\n  text-align: center;\n}\n\n.pot-info {\n  background-color: #bbb;\n  color: #000000;\n  margin-top: 2.5%;\n  padding: 1% 0% 0% 1%;\n  }\n  \n.pot-header {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  align-items: center;\n  justify-content: center;\n  }\n\n.pot-plants {\n  display: flex;\n  align-items: center;\n  width: 90%;\n  justify-content: space-between;\n  gap: 0.5em;\n  margin-top: 1em;\n}\n\n.pot-plants p {\n  flex: 1 1 0;\n  min-width: 0;\n  white-space: normal;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n  margin: 0;\n  text-align: left;\n}\n\n.plant-add-btn-container {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n}\n\n.status-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 5px 0;\n    font-size: small;\n  }\n\n.status-row > div {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    flex: 1;\n    font-size: small;\n}\n\n.extra-button{\n    background-color: #000;\n}\n\n\n.irrigate-select {\n    padding: 8px;\n    margin-right: 5px;\n    border-radius: 5px;\n    border: 1px solid #ccc;\n    background-color: white;\n    width: 60%;\n}\n\n.irrigate-select2 {\n  padding: 8px;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  background-color: white;\n  width: 100%;\n  margin-bottom: 2%;\n}\n\n.info-button {\n    background-color: transparent;\n    color: black;\n    border: none;\n    padding: 0;\n    font-size: 20px;\n    cursor: pointer;\n    margin-left: 5%;\n}\n\n.custom-days-input {\n    width: 50px;\n    height: 30px;\n    font-size: 12px;\n    padding: 4px;\n  }\n\n.pot-loading{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n.pot-width {\n    width: 100%;\n  }\n\n.pot-status {\n  width: 100%;\n  margin: 0 auto;\n}\n\n.scrollable-table {\n  overflow-x: visible;\n  margin-bottom: 2%;\n}\n\n.status-table {\n  width: 100%;\n  max-width: 100%;\n  table-layout: fixed;\n}\n\nth {\n  padding: 5px 0;\n  font-weight: bold;\n  border-bottom: 2px solid #000000;\n  white-space: normal;\n  font-size: clamp(0.75rem, 1.35vw, 0.95rem);\n}\n\ntd {\n  white-space: normal;\n  font-size: clamp(0.65rem, 1.1vw, 0.85rem);\n}\n\n.chart {\n  min-height: 400px;\n  width: 100%;\n  overflow-x: visible;\n}\n\n.date-picker-container {\n  padding: 20px;\n}\n\n.date-picker-container .react-datepicker-wrapper {\n  padding: 10px;\n}\n\n.date-picker-container .react-datepicker {\n  background-color: white;\n  border: 1px solid #ccc;\n}\n\n.date-picker-container .react-datepicker__input-container input {\n  width: 100%;\n  padding: 10px;\n  border: 2px solid #000000;\n  border-radius: 5px; \n  font-size: 16px;\n  background-color: #fff;\n  text-align: center;\n}\n\n.date-picker-container .react-datepicker__input-container input:focus {\n  outline: none;\n  border-color: #0056b3;\n  box-shadow: 0 0 5px rgba(0, 86, 179, 0.5);\n}\n\n.graph-container {\n  background-color: #ffffff;\n  color: rgb(0, 0, 0);\n  margin-top: 2.5%;\n  padding: 1% 0.5% 0.5% 1%;\n}\n\n.custom-legend {\n  display: flex;\n  gap: 20px;\n  cursor: pointer;\n  justify-content: center;\n  width: 100%;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  opacity: 1;\n  transition: opacity 0.2s;\n}\n\n.legend-item.inactive {\n  opacity: 0.4;\n}\n\n.legend-color {\n  width: 18px;\n  height: 5px;\n  display: inline-block;\n  border-radius: 2px;\n  margin-right: 3px;\n  border: none;\n  background: #aaa;\n}\n\n.legend-color.dashed {\n  border: 1.5px dashed #666;\n}\n\n.plant-name-flex {\n    flex: 1;\n}\n\n.two-col-row {\n    display: flex;\n    gap: 2rem;\n}\n\n.two-col-row .input-group {\n    flex: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
